import React from "react";
import "../Footer.css";

interface SocialMediaProps {
  socialLinks: {
    instagram: string;
    facebook: string;
    youtube: string;
    telegram: string;
    soundcloud: string;
    linkedin: string;
    spotify: string;
  };
}

const SocialMedia: React.FC<SocialMediaProps> = ({ socialLinks }) => {
  return (
    <div className="footer-social-media">
      <ul className="footer-social-list">
        <li className="footer-social-item">
          <a href={socialLinks.instagram} className="footer-social-link" target="_blank" rel="noopener noreferrer">
            <img
              src={require("../../../assets/img/insta.svg").default}
              alt="Instagram"
              className="footer-social-icon"
            />
          </a>
        </li>
        <li className="footer-social-item">
          <a href={socialLinks.facebook} className="footer-social-link" target="_blank" rel="noopener noreferrer">
            <img
              src={require("../../../assets/img/face.svg").default}
              alt="Facebook"
              className="footer-social-icon"
            />
          </a>
        </li>
        <li className="footer-social-item">
          <a href={socialLinks.youtube} className="footer-social-link" target="_blank" rel="noopener noreferrer">
            <img
              src={require("../../../assets/img/youtube.svg").default}
              alt="YouTube"
              className="footer-social-icon"
            />
          </a>
        </li>
        <li className="footer-social-item">
          <a href={socialLinks.telegram} className="footer-social-link" target="_blank" rel="noopener noreferrer">
            <img
              src={require("../../../assets/img/telegramPB.svg").default}
              alt="Telegram"
              className="footer-social-icon"
            />
          </a>
        </li>
        <li className="footer-social-item">
          <a href={socialLinks.soundcloud} className="footer-social-link" target="_blank" rel="noopener noreferrer">
            <img
              src={require("../../../assets/img/soundcloud.svg").default}
              alt="SoundCloud"
              className="footer-social-icon"
            />
          </a>
        </li>
        <li className="footer-social-item">
          <a href={socialLinks.linkedin} className="footer-social-link" target="_blank" rel="noopener noreferrer">
            <img
              src={require("../../../assets/img/linkedin.svg").default}
              alt="LinkedIn"
              className="footer-social-icon"
            />
          </a>
        </li>
        <li className="footer-social-item">
          <a href={socialLinks.spotify} className="footer-social-link" target="_blank" rel="noopener noreferrer">
            <img
              src={require("../../../assets/img/spotify.svg").default}
              alt="Spotify"
              className="footer-social-icon"
            />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default SocialMedia;
